<template>
  <div class="homeMb">
    <img class="homeMbImage" src="../assets/image/mbBg.png" />

    <div class="btnBox">
      <!-- <p style="color:white;margin-left:100px">是否ios: {{ isIos }}</p> -->
      <img class="iosBtn" @click="goIos" src="../assets/image/iosBtn.png" />
      <img class="adBtn" @click="goAd" src="../assets/image/adBtn.png" />
    </div>
    <div class="iosWrap" v-if="isIos">
      <img class="iosTipImg" src="../assets/image/iosTip.png">
    </div>
  </div>
</template>

<script>
import { getUrlKey } from '@/utils/utils'

export default {
  name: "homeMb",
  props: {
    msg: String
  },
  data() {
    return {
      count: 0,
      isIos: false,
    };
  },
  mounted() {
    if (/(micromessenger)/i.test(navigator.userAgent)) {
      //是否电脑微信或者微信开发者工具
      if (/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)) {
        // alert('电脑微信或者微信开发者工具')
      } else {
        //手机微信打开的浏览器
        //  alert('手机微信')
        let _ua = window.navigator.userAgent
        if (_ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
          this.isIos = true;
        } else {
          this.isIos = false;
        }
      }
    }

    // console.log(this.isIos);
  },
  methods: {
    goIos() {
      window.open("https://itunes.apple.com/cn/app/id1575026717");
      let channel = getUrlKey("download_channel");
      console.log(channel);
      setTimeout(() => {
        // console.log(window._hmt);
        window['_hmt'].push(['_trackEvent', 'mobile_ios_download_btn_click', channel === '1' ? '1' : '0']);
      }, 3000);
    },
    goAd() {
      window.open(
        "https://app.crypts.cn/appDownload/singular_fire_app_release.apk"
      );
      let channel = getUrlKey("download_channel");
      console.log(channel);
      setTimeout(() => {
        // console.log(window._hmt);
        window['_hmt'].push(['_trackEvent', 'mobile_android_download_btn_click', channel === '1' ? '1' : '0']);
      }, 3000);
    },
    sum(m, n) {
      var num = Math.floor(Math.random() * (m - n) + n);
      return num;
    }
  }
};
</script>

<style scoped lang="scss">
.iosWrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba($color: #000000, $alpha: 0.8);

  .iosTipImg {
    width: 100%;
    padding: 20px;
    object-fit: contain;
    box-sizing: border-box;

  }
}

.homeMb {
  width: 100%;
  height: 100%;
  background: #0b0c12;

  .homeMbImage {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .btnBox {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    // padding: 12%;
    padding-bottom: 8%;

    .iosBtn {
      width: 100%;
      height: 14vw;
      object-fit: contain;
    }

    .adBtn {
      width: 100%;
      margin-top: 4%;
      height: 14vw;
      object-fit: contain;
    }
  }
}
</style>
